export const bsbLogoWithoutName = require('../../assets/bsb_updates.png')
export const bsbLogofullnameWithBg = require('../../assets/logo_fullname_with_bg.png')
export const bsbLogofullnameWithoutBg = require('../../assets/logo_fullname_without_bg.png')